
import { RestrictionHolder } from "components/restrictions/Restrictions";
import {ComponentDefinition} from "./components/Component";

export class Bundle {
    public definition: ComponentDefinition;
    public data?: any;
    public options?;
    public restrictions?: RestrictionHolder;
    public focus?: string;

    public static create(definition: ComponentDefinition) {
        let bundle = new Bundle();
        bundle.definition = definition;
        return bundle;
    }
}

export function isBundle(arg: any): arg is Bundle {
    return arg != null && arg.definition !== undefined;
}
